import React, { Component } from "react";

import { withRouter } from "react-router-dom";

// redux
import { connect } from "react-redux";
import { login, clearErrors } from "../../store/actions/UserActions";

//mui
import { Paper, Button, CircularProgress } from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import NodeAuth from "node-auth-api";

import customStyles from "./Login.module.css";
import commonStyles from "../../commonModules/Spinner.module.css";
import Utils from "../../utils/Utils";
import Errors from "../common/Errors/Errors";
import { bindActionCreators } from "redux";

const styles = theme => ({
  root: {
    flexGrow: 1
  },
  progress: {
    margin: theme.spacing.unit * 2,
    color: "#00695c"
  },
  linearColorPrimary: {
    backgroundColor: "#b2dfdb"
  },
  linearBarColorPrimary: {
    backgroundColor: "#00695c"
  },
  circular_progress: {
    color: "#6798e5",
    animationDuration: "550ms",
    position: "absolute"
  }
});

class Login extends Component {
  state = {
    loading: false,
    email: '',
    password: '',
    emailError: null,
    passwordError: null,
    errors: []
  };  

  componentWillMount() {
    if(NodeAuth.User.isLoggedIn("user")) {
      this.props.history.push("/dashboard/tickets");
    }
  }


  login = () => {
    this.setState({ loading: true });
    const errors = {};

    if(this.state.email.length < 1) errors.emailError = "Please enter your email address";
    if(this.state.password.length < 1) errors.passwordError = "Please enter your password";
    
    if(Object.keys(errors).length > 0) {
      return this.setState({...errors, loading: false})
    }

    if(!Utils.isValidEmail(this.state.email)) errors.emailError = "Please enter a valid email";

    if(Object.keys(errors).length > 0) {
      return this.setState({...errors, loading: false})
    }

    // using context to maintain the current object context (Login.js) in callback function
    let context = this;
    this.props.userLogin(this.state.email, this.state.password, () => {
      context.props.history.push("/dashboard/tickets");
    });
  };

  handleChange = (e) => {
    let errors = {};
    // eg, email + Error = emailError
    errors[e.target.name + "Error"] = null;

    this.setState({
      [e.target.name]: e.target.value,
      ...errors
    })
  }

  clearErrors = () => {
    this.props.clearUserErrors();
  }

  render() {
    const { classes } = this.props;
    let { loading, errors } = this.props.user;
    const hasError = errors.length? true : false;
    return (
      <div className={`${customStyles.page} ${loading && commonStyles.spinner}`}>
        <Errors state={hasError} errors={errors} done={this.clearErrors} />
        <Paper className={customStyles.paper}>
          <h3>Go Bus | Dashboard</h3>
          <h4>Login</h4>
          <TextField
            error={this.state.emailError}
            className={customStyles.field}
            onChange={this.handleChange}
            helperText={this.state.emailError}
            id="email-field"
            name="email"
            placeholder="Email"
            margin="dense"
            variant="outlined"
            disabled={loading}
          />
          
          <TextField
            className={customStyles.field}
            onChange={this.handleChange}
            error={this.state.passwordError}
            helperText={this.state.passwordError}
            id="password-field"
            name="password"
            placeholder="Password"
            type="password"
            autoComplete="current-password"
            margin="normal"
            variant="outlined"
            disabled={loading}
          />
          <Button
            variant="contained"
            color="primary"
            disabled={loading}
            onClick={this.login}
            className={`${customStyles.field} ${customStyles.btn}`}
          >
            Login
          </Button>

          {/* {loading && (
            <CircularProgress
              variant="indeterminate"
              disableShrink
              className={classes.circular_progress}
              size={24}
              thickness={4}
            />
          )} */}
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.user
})

const mapDispatchToProps = dispatch => ({
  userLogin: bindActionCreators(login, dispatch),
  clearUserErrors: bindActionCreators(clearErrors, dispatch)
});


export default connect(mapStateToProps, mapDispatchToProps)(
  withStyles(styles)(
    withRouter(Login)
  )
);
